<template>
  <div class="navList">
    <div class="ingLog" @click="goDetilPage">
      <img src="./../assets/img/imglog.png" alt="sangfor" />
    </div>
    <ul class="navUl">
      <li v-for="(item, index) in this.navList" :key="item.id" @mouseover="handlehover('over', index)"
        @mouseleave="handlehover('leave')" class="navli" @click="handledetail(item.id)">
        <transition name="navDot"><span class="navDot" v-show="showNavMenu == index ? true : false"></span></transition>
        <a>{{ item.name }}</a>
        <transition name="navMenu-fade">
          <ul v-show="showNavMenu == index ? true : false" class="navMenu" ref="navMenu">
            <li v-for="(child, cIndex) in item.child" :key="child.id" class="menuList" v-show="item.name === 'Sales'
      ? child.isAdmin
        ? true
        : false
      : item.name === 'Tech Service'
        ? child.isAdmin
          ? true
          : false
        : true
      " @mouseenter="hoverchild('enter', cIndex)" @mouseleave="hoverchild('leave')"
              @click="handleSubmenu(child.name, child.id)">
              <p class="menuList_name">
                <transition name="childDot">
                  <div class="childDotBox">
                    <span class="childDot" v-show="showchildMenu == cIndex"></span>
                  </div>
                </transition>
                {{ child.name }}
              </p>
              <p class="menuList_info">{{ child.info }}</p>
              <i class="el-icon-arrow-right" v-if="child.child && child.child.length > 0"></i>
              <transition name="navChildMenu">
                <ul class="navChildMenu" ref="navChildMenu" v-show="showchildMenu == cIndex">
                  <li v-for="children in child.child" :key="children.id" class="childMenuList"
                    @mouseenter="hoverchildren('enter', cIndex)" @mouseleave="hoverchildren('leave')">
                    <p @click="jumpDocumentsIndex(children.jumpIndex, children.id)" :title="children.name">
                      <transition>
                        <div class="childrenDotBox">
                          <span class="childrenDot" v-show="showchildrenMenu == cIndex"></span>
                        </div>
                      </transition>
                      {{ children.name }}
                    </p>
                  </li>
                </ul>
              </transition>
            </li>
          </ul>
        </transition>
      </li>
    </ul>
    <div class="userInfoBox" v-if="!userInfo.name" @click="$router.push({ path: '/login', query: { scene: 'login' } })"
      style="margin-right: 15px">
      <el-button type="success">Login</el-button>
    </div>
    <div class="userInfoBox" v-else>
      <div class="headPortrait">
        {{ userInfo.name ? userInfo.name.substring(0, 1) : '' }}
      </div>
      <div class="userDropdown">
        {{ userInfo.surname || '' }} {{ userInfo.name }}
        <i class="el-icon-arrow-down"></i>
        <ul class="userDropdown_info">
          <li class="myProfile" @click="openProfile">
            <!-- 更改我的密码 -->
            <div class="userInfoDot"><span></span></div>
            My profile
          </li>
          <li class="changePassword" @click="changePassword">
            <!-- 更改我的密码 -->
            <div class="userInfoDot"><span></span></div>
            Change my password
          </li>
          <li class="logOut" @click="logOut">
            <div class="userInfoDot"><span></span></div>
            Exit
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Lockr from 'lockr'
import { removeAuth } from '@/utils/auth'
import { Encrypts } from '../utils/secret'
import { mapGetters } from 'vuex'
import { removePpToken } from '@/api/login.js'
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: 'navComponment',
  data() {
    return {
      hover: false,
      isActive: 0,
      showNavMenu: -1,
      showchildMenu: -1,
      showchildrenMenu: -1,
      // userInfo: {},
      id: '',
      navList: [
        // {
        //   id: 10,
        //   name: 'Home',
        //   child: []
        // },
        {
          id: 1,
          name: 'Home',
          child: []
        },
        {
          id: 2,
          name: 'Sales',
          child: [
            {
              id: 1,
              name: 'Opportunity Registration',
              info: 'Register and manage your opportunities',
              isAdmin: this.$store.state.userInfo.isAdmin === 4 ? false : true
            },
            {
              id: 2,
              name: 'Demo Management',
              info: 'Apply and manage your demo units',
              isAdmin: this.$store.state.userInfo.isAdmin === 4 ? false : true
            },
            // {
            //   id: 3,
            //   name: 'Online Sizing',
            //   info: 'Tools helping you to do sizing easily',
            //   isAdmin: this.$store.state.userInfo.isAdmin === 4 ? false : true
            // },
            //该菜单跳转老sp渠道端，新sp渠道端写在pp系统，此代码注释
            // {
            //   id: 4,
            //   name: 'Renewals',
            //   info: 'Tools helping you to  generate ongoing renewals',
            //   isAdmin: true
            // },
            {
              id: 5,
              name: 'Incentives',
              info: 'Rewards for partners that meet or exceed our plans and promotions',
              isAdmin: true,
              child: [
                // { id: 1, name: "Incentive Policy", jumpIndex: "INPO" },
                {
                  id: 20,
                  name: 'Incentive Policy',
                  jumpIndex: 'KB'
                }, //跳转知识库
                {
                  id: 126,
                  name: 'Product Promotion',
                  jumpIndex: 'KB'
                } //跳转知识库
              ]
            }
          ]
        },
        {
          id: 3,
          name: 'Marketing',
          child: [
            {
              id: 1,
              name: 'Market Development Funds (MDF)',
              info: 'Guideline to support your marketing campaigns',
              child: [
                { id: 559, name: 'MDF Guideline', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 689,
                  name: 'MDF Application',
                  jumpIndex: 'KB'
                } //跳转知识库
              ]
            },
            {
              id: 2,
              name: 'Marketing Resourses',
              info: 'Marketing resources library with tools, documents, and videos',
              child: [
                { id: 362, name: 'Cloud', jumpIndex: 'KB' }, //跳转知识库
                { id: 363, name: 'Security', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 691,
                  name: 'Corporate Branding',
                  jumpIndex: 'KB'
                } //跳转知识库
              ]
            }
          ]
        },
        {
          id: 4,
          name: 'Tech Service',
          child: [
            // {
            //   id: 1,
            //   name: "Tech Docs",
            //   info: "This is the introductionThis is the introductionThis is the introduction",
            //   child: [
            //     { id: 1, name: "IAG", jumpIndex: "TSIAG" },
            //     { id: 2, name: "Enport Secure", jumpIndex: "EnportSecure" },
            //     { id: 3, name: "NGAF", jumpIndex: "NGAF" },
            //     { id: 4, name: "WANO", jumpIndex: "WANO" },
            //     { id: 5, name: "aCloud", jumpIndex: "aCloud" },
            //     { id: 6, name: "VDI", jumpIndex: "TSVDI" },
            //   ],
            // },
            // {
            //   id: 1,
            //   name: 'Asset',
            //   info: 'Access asset management',
            //   isAdmin: true,
            //   child: []
            // },
            {
              id: 2,
              name: 'Cases',
              info: 'Access cases',
              isAdmin: this.$store.state.userInfo.isAdmin === 3 ? false : true
            },
            {
              id: 3,
              name: 'Knowledge Base',
              info: 'Technical resources library',
              isAdmin: true,
              child: [
                { id: 580, name: 'IAG', jumpIndex: 'KB' },
                { id: 587, name: 'Endpoint Secure', jumpIndex: 'KB' },
                { id: 594, name: 'Cyber Command', jumpIndex: 'KB' },
                { id: 601, name: 'NGAF', jumpIndex: 'KB' },
                { id: 608, name: 'SDWAN', jumpIndex: 'KB' },
                { id: 637, name: 'ADC', jumpIndex: 'KB' },
                { id: 645, name: 'HCI', jumpIndex: 'KB' },
                { id: 660, name: 'VDI', jumpIndex: 'KB' }
              ]
            },
            {
              id: 4,
              name: 'Technical Manual',
              info: 'Sangfor products technical manual',
              isAdmin: true,
              child: [
                { id: 113, name: 'IAG', jumpIndex: 'KB' },
                { id: 517, name: 'Cyber Command', jumpIndex: 'KB' },
                { id: 518, name: 'NGAF', jumpIndex: 'KB' },
                { id: 519, name: 'WANO', jumpIndex: 'KB' },
                { id: 528, name: 'HCI', jumpIndex: 'KB' },
                { id: 529, name: 'VDI', jumpIndex: 'KB' }
              ]
            }
          ]
        },
        {
          id: 5,
          name: 'Products & Solutions',
          child: [
            {
              id: 1,
              name: 'Products',
              info: 'All the documents you need across the whole sales cycle',
              child: [
                {
                  id: 22,
                  name: 'Next Generation Application Firewall',
                  jumpIndex: 'KB'
                }, //跳转知识库
                { id: 23, name: 'Internet Access Gateway', jumpIndex: 'KB' }, //跳转知识库
                { id: 24, name: 'Cyber Command', jumpIndex: 'KB' }, //跳转知识库
                { id: 127, name: 'Endpoint Secure', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 128,
                  name: 'Hyper Converged Infrastructure',
                  jumpIndex: 'KB'
                }, //跳转知识库
                { id: 129, name: 'Mangaed Cloud Service', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 130,
                  name: 'Virtual Desktop Infrastructure',
                  jumpIndex: 'KB'
                } //跳转知识库
              ]
            },
            {
              id: 2,
              name: 'Solutions',
              info: 'Most popular solutions that you need to be clear',
              child: [
                { id: 337, name: 'Ransomware Solution', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 338,
                  name: 'Continuous Detection and Simplified Secops',
                  jumpIndex: 'KB'
                }, //跳转知识库
                { id: 339, name: 'Secure Internet Access', jumpIndex: 'KB' }, //跳转知识库
                {
                  id: 340,
                  name: 'NG-CDI',
                  jumpIndex: 'KB'
                }, //跳转知识库
                {
                  id: 341,
                  name: 'Backup and DR',
                  jumpIndex: 'KB'
                }, //跳转知识库
                // { id: 5, name: "PaaS", jumpIndex: "Paas" },
                {
                  id: 342,
                  name: 'Managed Cloud Service',
                  jumpIndex: 'KB'
                }, //跳转知识库
                {
                  id: 343,
                  name: 'Healthcare Solutions',
                  jumpIndex: 'KB'
                }, //跳转知识库
                {
                  id: 344,
                  name: 'Manufacturing Solutions',
                  jumpIndex: 'KB'
                } //跳转知识库
              ]
            }
          ]
        },
        {
          id: 985,
          name: 'Industry',
          child: [
            {
              id: 987,
              name: 'Battle Map',
              child: [
                {
                  id: 989,
                  name: 'Battle Map',
                  jumpIndex: 'KB'
                }
              ]
            },
            {
              id: 991,
              name: 'Industry Background-Outline',
              child: [
                {
                  id: 993,
                  name: 'Industry Background-Outline',
                  jumpIndex: 'KB'
                }
              ]
            },
            {
              id: 995,
              name: 'Industry Opportunities and Solutions',
              child: [
                {
                  id: 997,
                  name: 'Industry Opportunities and Solutions',
                  jumpIndex: 'KB'
                }
              ]
            },
            {
              id: 999,
              name: 'Industry Case Studying',
              child: [
                {
                  id: 1001,
                  name: 'Industry Case Studying',
                  jumpIndex: 'KB'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    handlehover(data, index) {
      if (data === 'over') {
        this.showNavMenu = index
      } else {
        this.showNavMenu = -1
      }
    },
    hoverchild(data, index) {
      if (data === 'enter') {
        this.showchildMenu = index
      } else {
        this.showchildMenu = -1
      }
    },
    hoverchildren(data, index) {
      if (data === 'enter') {
        this.showchildrenMenu = index
      } else {
        this.showchildrenMenu = -1
      }
    },
    openProfile() {
      this.$router.push({ path: '/personalCenter', query: { index: '1' } })
    },
    //点击跳转更改密码
    changePassword() {
      this.$router.push({ path: '/personalCenter', query: { index: '2' } })
    },
    //点击log返回详情页
    goDetilPage() {
      // this.$router.push({ path: "/personalInformation" });
      this.$router.push({ path: '/' })
    },
    jumpDocumentsIndex(name, id) {
      let token = localStorage.getItem('access_token_mh') ? encodeURIComponent(localStorage.getItem('access_token_mh')) : ''
      switch (name) {
        case 'AF':
          this.$router.push({ path: '/documentsIndex/afIndex' })
          break
        case 'IAG':
          this.$router.push({ path: '/documentsIndex/iagIndex' })
          break
        case 'CC':
          this.$router.push({ path: '/documentsIndex/cyberCommand' })
          break
        case 'ES':
          this.$router.push({ path: '/documentsIndex/esIndex' })
          break
        case 'HCI':
          this.$router.push({ path: '/documentsIndex/hciIndex' })
          break
        case 'MCS':
          this.$router.push({ path: '/documentsIndex/mcsIndex' })
          break
        case 'VDI':
          this.$router.push({ path: '/documentsIndex/vdiIndex' })
          break
        case 'PDPM':
          this.$router.push({ path: '/documentsIndex/productPromotion' })
          break
        case 'Cloud':
          this.$router.push({
            path: '/documentsIndex/marketingResourses',
            query: { unfoldArr: '1,2', showItem: 3, title: 'Cloud', showId: 1 }
          })
          break
        case 'Security':
          this.$router.push({
            path: '/documentsIndex/security',
            query: {
              unfoldArr: '1,2',
              showItem: 3,
              title: 'Security',
              showId: 1
            }
          })
          break
        case 'KB':
          if (id === 689) {
            window.open('https://go.sangfor.com/mdf-application-form')
          } else {
            if (token) {
              window.open(getCurrentHost(process.env.VUE_APP_API_KB,process.env.VUE_APP_EU_API_KB) + 'indexPage?module=' + id + '?token=' + token + '?2')
            } else {
              window.open(getCurrentHost(process.env.VUE_APP_API_KB,process.env.VUE_APP_EU_API_KB) + 'indexPage?module=' + id)
            }
          }
      }
    },
    handledetail(id) {

      console.log('%c [  ]-479', 'font-size:13px; background:pink; color:#bf2c9f;', id)
      if (id == 1) {
        this.$router.push({ path: '/' })
      } else if (id == 10) {
        this.$router.replace({ path: '/layout' })
      }
    },
    //点击二级菜单
    handleSubmenu(name, id) {
      let PPHost = getCurrentHost(process.env.VUE_APP_API_PPHOST, process.env.VUE_APP_EU_API_PPHOST)
      let hostData = getCurrentHost(process.env.VUE_APP_CAS_URL,process.env.VUE_APP_EU_URL) 
      let token = localStorage.getItem('access_token_mh') ? encodeURIComponent(localStorage.getItem('access_token_mh')) : ''
      let toPortalsUrl = localStorage.getItem('to_portals-url')

      console.log('%c [  ]-489', 'font-size:13px; background:pink; color:#bf2c9f;', toPortalsUrl)
      console.log('%c [  ]-509', 'font-size:13px; background:pink; color:#bf2c9f;', token)
      console.log(name)
      if (name == 'Opportunity Registration') {
        if (token) {
           window.open(PPHost + 'dealReg')
        } else {
          localStorage.setItem('linkObj', JSON.stringify({ scene: 'navJump', url: 'dealReg' }))
          location.replace(hostData)
        }
      } else if (name == 'Demo Management') {
        if (token) {
           window.open(PPHost + 'demoUnit')
        } else {
          localStorage.setItem('linkObj', JSON.stringify({ scene: 'navJump', url: 'demoUnit' }))
          location.replace(hostData)
        }
      }

      //跳转老sp渠道端，新sp渠道端写在pp系统中，此代码注释
      // else if (name == 'Renewals') {
      //   window.open(
      //     process.env.VUE_APP_API_SPHOST +
      //     '?sp_info=' +
      //     encodeURIComponent(this.$store.state.spUserInfo)
      //   )
      //   // window.open("http://10.4.248.177:3000?sp_info=" + encodeURIComponent((this.$store.state.spUserInfo)));
      // }
      // else if (name == 'Asset') {
      //   if (token) {
      //     if (toPortalsUrl) {
      //       window.open(toPortalsUrl)
      //     } else {
      //       window.open(hostData + 'myAssest/myAssetsIndex?token=' + token)
      //     }
      //   } else {
      //     localStorage.setItem('linkObj', JSON.stringify({ scene: 'navJump', url: 'myAssest/myAssetsIndex' }))
      //     location.replace(process.env.VUE_APP_CAS_URL)
      //   }
      // }
      else if (name.substring(0, 3) == 'MDF') {
        this.$router.push({ path: '/MDFPage' })
      } else if (name === 'Cases') {
        if (token) {
           window.open(PPHost + 'tickets')
        } else {
          localStorage.setItem('linkObj', JSON.stringify({ scene: 'navJump', url: 'tickets' }))
          location.replace(hostData)
        }
      }
      // else if (name === 'Online Sizing') {
      //   if (token) {
      //     if (toPortalsUrl) {
      //       window.open(toPortalsUrl)
      //     } else {
      //       window.open(process.env.VUE_APP_API_PPHOST + 'productSelection/productSelection?token=' + token)
      //     }
      //   } else {
      //     localStorage.setItem('linkObj', JSON.stringify({ scene: 'navJump', url: 'productSelection/productSelection' }))
      //     location.replace(process.env.VUE_APP_CAS_URL)
      //   }
      // }
      //    else if (name == 'Solutions') {
      //     this.$router.push({
      //       path: '/documentsIndex/productSolution',
      //       query: { unfoldArr: [1], showItem: 20, hasChild: false },
      //     })
      //   }
    },
    removeLocalStorage() {
      localStorage.removeItem('access_token_mh')
      localStorage.removeItem('idt_token')
      Lockr.set('access_pp_token', '')
      localStorage.removeItem('sp_info')
      removeAuth()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('to_portals-url')
      // 清除store
      this.$store.commit('SET_USERINFO', {})
      this.$store.commit('SET_SPUSERINFO', {})
      this.$router.push({ path: '/' })
      // window.location.href = '/detailsPage'
    },
    // idt注销
    logOutIdt() {
      let hostName = window.location.hostname;
      let {NODE_ENV,VUE_APP_ML_HOST} = process.env
      if (localStorage.getItem('idt_token') && localStorage.getItem('access_token_mh')) {
        removePpToken(localStorage.getItem('idt_token'), localStorage.getItem('access_token_mh'),NODE_ENV === "production" && hostName != VUE_APP_ML_HOST ? "eu" : "mo")
          .then(res => {
            this.removeLocalStorage()
          })
          .catch(() => {
            this.$message({
              message: 'Unregistration failed.',
              type: 'warning'
            })
          })
      } else {
        this.$message({
          message: 'Exiting status, we will refresh the page for you later.',
          type: 'warning',
          onClose: () => {
            window.location.reload()
          }
        })
      }
    },
    //登出
    logOut() {
      this.$confirm('Confirm to log out?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          // localStorage.removeItem('access_token_mh')
          // Lockr.set('access_pp_token', '')
          // localStorage.removeItem('sp_info')
          // removeAuth();
          this.logOutIdt()
        })
        .catch(() => { })
    }
  },
  created() {
    // this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (this.$route.query.status == 'logOutIdt') {
      this.removeLocalStorage()
    }
  }
}
</script>

<style scoped lang="scss">
.navList {
  width: 100%;
  height: 104px;
  padding: 0 600px 0 500px;
  background: #fff;
  position: relative;

  .ingLog {
    position: absolute;
    top: 27px;
    left: 100px;
    width: 156px;
    height: 51px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .navUl {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .navli {
      position: relative;
      padding: 0 14px;
      height: 100%;
      display: flex;
      align-items: center;

      &:hover {
        a {
          color: rgba(81, 85, 94, 1);
          font-size: 20px;
        }
      }

      .navDot {
        position: absolute;
        top: 49px;
        left: 0;
        width: 6px;
        height: 6px;
        background: #65bb10;
        border-radius: 50%;
      }

      .navDot-enter-active {
        transition: all 0.3s ease;
      }

      .navDot-leave-active {
        transition: all 0.1s ease;
      }

      .navDot-enter {
        transform: translateX(-5px);
      }

      .navDot-leave-to {
        opacity: 0;
      }

      a {
        color: #9e9fb7;
        text-decoration: none;
        font-size: 20px;
        //font-family: Source Han Sans CN;
        font-weight: 600;
      }

      .navMenu {
        position: absolute;
        top: 104px;
        left: -300px;
        background: #fff;
        padding: 15px 0;
        box-shadow: 9px 10px 38px #c1c8db;
        border-radius: 8px;
        z-index: 99;

        .menuList {
          position: relative;
          padding: 10px 60px 10px 30px;

          &:hover {
            background: #f2f6ff;
            font-weight: bold;

            .menuList_name {
              color: #51555e;

              .childDotBox {
                width: 16px;
              }
            }
          }

          .menuList_name {
            white-space: nowrap;
            font-size: 20px;
            color: rgba(81, 85, 94, 1);
            text-align: left;
            display: flex;
            align-items: center;

            .childDotBox {
              width: 6px;
              transition: width 0.3s;
              display: flex;

              .childDot {
                width: 6px;
                height: 6px;
                background: #65bb10;
                border-radius: 50%;
                margin-right: 10px;
                transition: all 0.5s;
              }
            }
          }

          .menuList_info {
            white-space: nowrap;
            font-size: 16px;
            color: rgba(81, 85, 94, 1);
            text-align: left;
            margin-top: 12px;
            margin-left: 10px;
          }

          .el-icon-arrow-right {
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            right: 20px;
            font-size: 16px;
            color: #6b74f2;
          }

          .navChildMenu {
            width: 450px;
            background: #fff;
            border-radius: 8px;
            position: absolute;
            top: 0;
            right: -450px;
            z-index: 999;
            box-shadow: 9px 10px 38px #c1c8db;

            .childMenuList {
              padding: 0 30px;
              border-radius: 8px;

              &:hover {
                background: #f2f6ff;

                p {
                  color: rgba(81, 85, 94, 1);
                  font-size: 20px;

                  .childrenDotBox {
                    width: 16px;
                  }
                }
              }

              p {
                width: 100%;
                text-align: left;
                font-size: 20px;
                color: #7f8394;
                padding: 25px 0;
                display: flex;
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .childrenDotBox {
                  width: 6px;
                  transition: width 0.3s;
                  display: flex;

                  .childrenDot {
                    width: 6px;
                    height: 6px;
                    background: #65bb10;
                    border-radius: 50%;
                    margin-right: 10px;
                    transition: all 0.3s;
                  }
                }
              }
            }
          }

          .navChildMenu-enter-active,
          .navChildMenu-leave-active {
            transition: opacity 0.3s;
          }

          .navChildMenu-enter,
          .navChildMenu-leave-to {
            opacity: 0;
          }
        }
      }

      .navMenu-fade-enter-active,
      .navMenu-fade-leave-active {
        transition: opacity 0.3s;
      }

      .navMenu-fade-enter,
      .navMenu-fade-leave-to {
        opacity: 0;
      }
    }

    .navli:nth-child(5) {
      .navMenu {
        position: absolute;
        top: 104px;
        left: 0;
      }
    }
  }

  .userInfoBox {
    width: fit-content;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    display: flex;
    align-items: center;
    height: 100%;

    .headPortrait {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      color: red;
      font-size: 18px;
      text-align: center;
      line-height: 44px;
      background: #ccc;
      cursor: default;
    }

    .userDropdown {
      padding: 0 16px;
      font-size: 16px;
      color: #7a7b80;
      font-weight: 400;
      position: relative;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;

      &:hover {
        .userDropdown_info {
          opacity: 1;
        }
      }

      i {
        margin-left: 10px;
      }

      .userDropdown_info {
        width: 230px;
        position: absolute;
        top: 104px;
        right: 1px;
        background: #ffffff;
        box-shadow: 9px 10px 38px #c1c8db;
        border-radius: 8px;
        padding: 13px 30px;
        transition: opacity 0.3s;
        opacity: 0;

        li {
          padding: 13px 10px;
          text-align: left;
          color: #7a7b80;
          display: flex;

          .userInfoDot {
            width: 6px;
            transition: width 0.3s;
            display: flex;
            align-items: center;

            span {
              width: 6px;
              height: 6px;
              background: #65bb10;
              border-radius: 50%;
              margin-right: 8px;
            }
          }

          &:hover {
            color: #51555e;

            .userInfoDot {
              width: 16px;

              span {}
            }
          }
        }
      }
    }
  }
}
</style>
